/* T.LUXY V7: defensive support for product-size label clicks.
   Uses the native radio and its change event; Palo Alto remains responsible
   for resolving Shopify variants and adding the selected variant to cart. */
(() => {
  const sizeLabel = (target) => target.closest?.('.selector-wrapper--tluxy-size label.radio__label');

  document.addEventListener('click', (event) => {
    const label = sizeLabel(event.target);
    if (!label) return;
    const input = label.htmlFor && document.getElementById(label.htmlFor);
    if (!input || input.type !== 'radio' || input.disabled) return;

    // Normally the browser checks the radio and emits `change` automatically.
    // If another theme overlay/handler prevents that default action, restore
    // the native selection and notify the existing variant-selects component.
    window.setTimeout(() => {
      if (!document.contains(input) || input.disabled || input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 0);
  });
})();
